<template>
  <div :class="bem()">
    <template
      v-for="accordion in props.accordions"
      :key="accordion.id"
    >
      <VisionAccordion
        display-as-block-at-breakpoint="md"
        :default-expanded="accordion.accordionType === 'productAttributeRatingsPerformance'"
        :no-border="true"
        :class="
          bem('accordion', {
            performance:
              accordion.accordionType === 'productAttributeRatingsPerformance',
          })
        "
      >
        <template #header>
          <h4 :class="bem('title')">{{ accordion.heading }}</h4>
        </template>
        <template #body>
          <div :class="bem('content')">
          <AccordionGenericProductAttributes
            v-if="accordion.accordionType === 'productAttributeRatings'"
            :product-attribute="accordion.productAttribute"
          />
          <AccordionPerformanceProductAttributes
            v-else-if="
              accordion.accordionType === 'productAttributeRatingsPerformance'
            "
            :product-attribute="accordion.productAttribute"
            :customised-product="props.customisedProduct"
            :key-features-title="accordion.keyFeaturesTitle"
            :key-features-tooltip="accordion.keyFeaturesTooltip"
            :conditions-title="accordion.conditionsTitle"
            :conditions-tooltip="accordion.conditionsTooltip"
          />
          <InTheBoxCarousel
            v-else-if="accordion.accordionType === 'inTheBox'"
            :customised-product="props.customisedProduct"
            :layer-template="props.layerTemplate"
            :show-360="props.show360"
            :show-iris-preview="props.showIrisPreview"
          />
          <AccordionCardGrid
            v-else-if="accordion.accordionType === 'cards'"
            :cards="accordion.cards"
          />
          </div>
        </template>
      </VisionAccordion>
    </template>
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('ProductInfoAccordion')

const props = defineProps({
  customisedProduct: {
    type: Object,
    default: () => {},
  },
  layerTemplate: { type: Object, default: () => ({}) },
  show360: { type: Boolean, required: true },
  showIrisPreview: { type: Boolean, required: true },
  accordions: { type: Array, required: true },
})
</script>

<style lang="postcss">
.is-dark-chrome-theme {
  .ProductInfoAccordion__title {
    @apply text-white;
  }

  .ProductInfoAccordion__accordion {
    .VisionIcon {
      --vision-icon-fill: theme('colors.white');
    }
  }
}
.ProductInfoAccordion {
  @apply flex flex-col md:gap-10 flex-wrap global-wrapper md:global-wrapper-reset;

  @media (min-width: 1201px) {
    @apply flex-row;
  }
}

.ProductInfoAccordion__accordion {
  @apply w-full border-t-2 border-grey-400 min-w-0;

  @screen mdMax {
    @apply order-2
  }

  @media (min-width: 1201px) {
    width: calc(50% - 1.25rem);
  }
}

.ProductInfoAccordion__accordion--performance {
  @screen mdMax {
    @apply order-1;
  }
}

.ProductInfoAccordion__content {
  @apply mdMax:pb-8;
}

.ProductInfoAccordion__title {
  @apply heading-4 text-off-black;
}
</style>
